import api from './api';

export const guestMessageAPI = {
    list: (page = 1, limit = 20) =>
        api.get('/guest-messages/', { params: { page, limit } }),
    get: (id) => api.get(`/guest-messages/${id}`),
    convertContact: (id, workspace_id) =>
        api.put(`/guest-messages/${id}/convert-contact`, { workspace_id }),
    convertTask: (id, space_id, list_id) =>
        api.put(`/guest-messages/${id}/convert-task`, { space_id, list_id }),
    delete: (id) => api.delete(`/guest-messages/${id}`),
    archive: (id) => api.patch(`/guest-messages/${id}/archive`),
};